import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Certificate } from '../models/certificate.model';
import { SelectItemEvent } from '../../shared/models/selectItemEvent.model';
import { EventCertificatePlatform } from 'src/app/shared/models/eventCertificatePlatform.model';

@Injectable()
export class CertificateService {

  constructor(private httpClient: HttpClient) {
  }

  public list() {
    return this.httpClient.get<Array<Certificate>>('/api/certificate');
  }

  public mail(id: number) {
    return this.httpClient.get('/api/certificate/mail?id=' + id);
  }

  public mailAttendance() {
    return this.httpClient.get('/api/certificate/mail/attendance');
  }

  public mailCME() {
    return this.httpClient.get('/api/certificate/mail/cme');
  }

  public download(id: number) {
    return this.httpClient.get('/api/certificate/download?id=' + id, { responseType: 'blob', observe: 'response' });
  }

  public downloadAttendance() {
    return this.httpClient.get('/api/certificate/download/attendance', { responseType: 'blob', observe: 'response' });
  }

  public downloadCME() {
    return this.httpClient.get('/api/certificate/download/cme', { responseType: 'blob', observe: 'response' });
  }

  public availableEvents() {
    return this.httpClient.get<Array<SelectItemEvent>>('/api/certificate/availableEvents');
  }

  public getEventCertificatePlatform() {
    return this.httpClient.get<EventCertificatePlatform>('/api/certificate/eventCertificatePlatform');
  }
}
